<template>
  <div class="container-fluid full-width-page-wrapper">
    <h3 class="font-weight-bold page-title">IFAC Technical Areas</h3>

    <ifac-loader v-if="busy" />
    <ifac-technical-areas-accordion
      v-else
      :coordinating-committees="coordinatingCommittees"
    />
  </div>
</template>

<script>
import { IfacLoader, IfacTechnicalAreasAccordion } from '@ifac/ui';
import TechnicalAreas from '@/services/Api/Public/TechnicalAreas';

export default {
  name: 'TechnicalAreas',
  components: {
    IfacLoader,
    IfacTechnicalAreasAccordion,
  },
  data() {
    return {
      busy: true,
      coordinatingCommittees: [],
    };
  },
  async created() {
    try {
      const response = await TechnicalAreas.get();
      this.coordinatingCommittees = response.data.data.coordinatingCommittees;
    } finally {
      this.busy = false;
    }
  },
};
</script>
